import { TimePicker } from 'antd';
import React from 'react';
import { BaseFormItem } from './BaseFormItem';
import { IBaseFormItemProps } from './form.type';

interface IProps extends React.ComponentProps<typeof TimePicker>, IBaseFormItemProps {}

export function BaseTimePicker(props: IProps) {
  return (
    <BaseFormItem {...props}>
      <TimePicker
        {...props}
        size={props.size || 'large'}
        placeholder={props.placeholder || props.label}
        style={{ width: '100%' }}
      />
    </BaseFormItem>
  );
}
